import React from "react";
import { App } from "../firebase";
import { API_URL } from "../constant";

function Popup(data) {
  const { type, withup } = data;
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [loading, setLoading] = React.useState(false);
  const isAfterPay = window.location.search == "?pay=checking";
  React.useEffect(() => {
    if (isAfterPay) {
      setTimeout(() => {
        //   history.push("/recapitulatif");

        if (type == "acceptpay") {
          var modal = document.getElementById(type);
          modal.style.display = "block";
          setTimeout(() => {
            window.location.href =
              window.location.origin + window.location.pathname;
          }, 10000);
        }
      }, 1500);
    }
    if (type != "promptrdvcancel")
      window.onclick = function (event) {
        // alert(type);
        var modal = document.getElementById(type);
        if (event.target == modal) {
          if (modal && modal.style) modal.style.display = "none";

          if (type == "rdvcancel") {
            window.location.reload();
          } else {
            if (type == "acceptpay") {
              // console.log(window.location);
            }
          }
        }
      };

    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const Accept = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: size.width <= 428 && "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "18px auto",
          }}
        >
          <div
            style={{
              width: 70,
              height: 70,
              margin: 14,
            }}
          >
            <img
              alt=""
              src="/check-circle.png"
              style={{
                width: 70,
                height: 70,
              }}
            />
          </div>
          <div className="col-75">
            <p
              class="raleway-bold-eerie-black-25px"
              style={{
                marginBottom: size.width <= 428 ? 20 : 5,
                textAlign: size.width <= 428 && "center",
                marginTop: size.width <= 428 && 5,
              }}
            >
              Paiement accepté
            </p>
            <p
              className="raleway-semi-bold-eerie-black-15px"
              style={{
                textAlign: size.width <= 428 && "center",
              }}
            >
              Votre réservation a bien été confirmée. Un SMS de rappel vous sera
              envoyé 4h avant votre RDV.
            </p>
          </div>
        </div>
        <p
          className="raleway-normal-silver-15px"
          style={{
            color: "#707070",
            textAlign: "center",
            marginBottom: 18,
          }}
        >
          Vous allez être redirigé vers votre page de réservation.
        </p>
      </>
    );
  };
  const CancelPay = () => {
    return (
      <>
        <span
          class="close"
          onClick={() => {
            var modal = document.getElementById(type);
            modal.style.display = "none";
          }}
        >
          &times;
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: size.width <= 428 && "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "18px auto",
          }}
        >
          <div
            style={{
              width: 70,
              height: 70,
              margin: 14,
            }}
          >
            <img
              alt=""
              src="/cancel.png"
              style={{
                width: 70,
                height: 70,
              }}
            />
          </div>
          <div className="col-75">
            <p
              class="raleway-bold-eerie-black-25px"
              style={{
                marginBottom: size.width <= 428 ? 20 : 5,
                textAlign: size.width <= 428 && "center",
                marginTop: size.width <= 428 && 5,
              }}
            >
              Paiement échoué
            </p>
            <p
              className="raleway-semi-bold-eerie-black-15px"
              style={{
                textAlign: size.width <= 428 && "center",
              }}
            >
              Votre paiement n’a pas pu aboutir. Veuillez ré-essayer ou
              contacter votre banque.
            </p>
          </div>
        </div>
      </>
    );
  };

  const CancelRdv = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: size.width <= 428 && "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "18px auto",
          }}
        >
          <div
            style={{
              width: 70,
              height: 70,
              margin: 14,
            }}
          >
            <img
              alt=""
              src="check-circle.png"
              style={{
                width: 70,
                height: 70,
              }}
            />
          </div>
          <div className="col-75">
            <p
              class="raleway-bold-eerie-black-25px"
              style={{
                marginBottom: size.width <= 428 ? 20 : 5,
                textAlign: size.width <= 428 && "center",
                marginTop: size.width <= 428 && 5,
              }}
            >
              Votre rendez-vous a bien été annulé.
            </p>
          </div>
        </div>
      </>
    );
  };

  const PromptCancelRdv = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: size.width <= 428 && "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "18px auto",
          }}
        >
          <div
            style={{
              width: 70,
              height: 70,
              margin: 14,
            }}
          >
            <img
              alt=""
              src="warning.png"
              style={{
                width: 70,
                height: 70,
              }}
            />
          </div>
          <div className="col-75">
            <p
              class="raleway-bold-eerie-black-25px"
              style={{
                marginBottom: size.width <= 428 ? 20 : 5,
                textAlign: size.width <= 428 && "center",
                marginTop: size.width <= 428 && 5,
              }}
            >
              Voulez-vous vraiment annuler votre rendez-vous ?
            </p>
            <p
              className="raleway-normal-silver-15px"
              style={{
                color: "#707070",
                marginTop: 18,
                fontSize: "16px",
                textAlign: size.width <= 428 && "center",
              }}
            >
              Attention conformément à l’article L214-1 du code de la
              consommation, les arrhes ne peuvent être remboursés, par
              conséquent si vous avez déjà payé un acompte il sera perdu.
            </p>
          </div>
        </div>
        <div
          style={{
            margin: "auto",
            padding: "35px 0px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Popup type="rdvcancel" withup={withup} />

          <div style={{ width: 100 }}>
            <a
              onClick={() => {
                var modal = document.getElementById(type);
                modal.style.display = "none";
              }}
            >
              <div
                class=" border-2px-eerie-black"
                style={{
                  cursor: "pointer",
                  borderRadius: 10,
                  display: "flex",
                  height: 55,
                  width: 100,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div class="sinscrire raleway-semi-bold-black-18px" style={{}}>
                  Fermer
                </div>
              </div>
            </a>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {type === "promptrdvcancel" && (
        <a
          onClick={() => {
            var modal = document.getElementById(type);
            modal.style.display = "block";
          }}
        >
          <div
            class="modifier-mon-rdv raleway-bold-eerie-black-15px"
            style={{ marginLeft: size.width > 428 && 30 }}
          >
            Annuler mon RDV
          </div>
        </a>
      )}

      {type == "rdvcancel" && (
        <button
          id="myBtn"
          class="bouton-plein border-1px-dove-gray"
          style={{
            height: 55,
            marginRight: "20px",
            maxWidth: 340,
          }}
          onClick={() => {
            //   history.push("/recapitulatif");
            if (!loading) {
              setLoading(true);

              const { currentUser: fuser } = App.auth();
              var myHeaders = new Headers();
              myHeaders.append("Content-Type", "application/json");
              var raw = JSON.stringify({
                cartId: withup.id,
                user: fuser.uid,
              });
              var requestOptions = {
                method: "DELETE",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
              };
              fetch(API_URL + "cancel_rdv", requestOptions)
                .then((res) => res.json())
                .then((data) => {
                  setLoading(false);
                  console.log(data);
                  if (data.success) {
                    //afficher automatiquement et reload
                    var modal = document.getElementById("rdvcancel");
                    modal.style.display = "block";
                    setTimeout(() => {
                      window.location.reload(); // ou au clique
                    }, 1500);
                  } else {
                    alert("Une erreur s'est produite");
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err);
                  alert("Une erreur s'est produite");
                });
            }
          }}
        >
          <div class="prendre-rdv raleway-semi-bold-white-18px">
            {loading ? "Chargement ..." : "J’annule mon rdv"}
          </div>
        </button>
      )}
      <div
        id={type}
        class="modal"
        onClick={() => {
          var modal = document.getElementById(type);
          if (modal && modal.style && type != "promptrdvcancel")
            modal.style.display = "none";
          if (type == "acceptpay" || type == "rdvcancel") {
            window.location.href =
              window.location.origin + window.location.pathname;
          }
        }}
      >
        <div
          class="modal-content content-sha"
          style={{
            maxWidth:
              type == "rdvcancel" ? 698 : type == "promptrdvcancel" && 807,
          }}
        >
          {type == "promptrdvcancel" && <PromptCancelRdv />}
          {type == "rdvcancel" && <CancelRdv />}

          {type == "acceptpay" && <Accept />}
          {type == "cancelpay" && <CancelPay />}
        </div>
      </div>
    </>
  );
}

export default Popup;
